import './custom.css'
import './preview.css'

import React, { useState, useCallback, useEffect } from 'react';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';

import { Home } from './components/Home';
import { Campaigns } from './components/Campaigns';
import { Campaign } from './components/Campaign';
import { Analytics } from './components/Analytics';
import { Analytic } from './components/Analytic';
import { Settings } from './components/Settings';
import { Widgets } from './components/Widgets';
import { Widget } from './components/Widget';
import { Themes } from './components/Themes';
import { Theme } from './components/Theme';
import { Login } from './components/Login';
import { Error } from './components/Error';
import { Faq } from './components/Faq';
import { Billing } from './components/Billing';
import { Partners } from './components/Partners';
import { Advanced } from './components/Advanced';
import { Announcements } from './components/Announcements';
import { DiscountRedirect } from './components/DiscountRedirect';
import { Layout } from './components/Layout';
import { useSafeAppBridge } from "./hooks";

function App() {

    const shopify = useSafeAppBridge();
    const isEmbed = shopify !== null;

    const l_user = JSON.parse(localStorage.getItem('user')) ?? { myShopifyDomain: isEmbed ? shopify.config.shop : '' };

    const [isLoading, setIsLoading] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const [toastActive, setToastActive] = useState(false);
    const [toastMessage, setToastMessage] = useState('Changes saved');
    const [triggerSave, setTriggerSave] = useState(false);
    const [triggerDiscard, setTriggerDiscard] = useState(false);
    const [user, setUser] = useState(l_user);
    const [userLoaded, setUserLoaded] = useState(false);

    const changeToastActive = function (toastActive, toastMessage) {
        if (!toastMessage) {
            toastMessage = "Changes saved";
        }
        setToastActive(toastActive);
        setToastMessage(toastMessage);
    };

    const toggleToastActive = useCallback(
        () => setToastActive(!toastActive),
        [toastActive],
    );

    useEffect(() => {
        let saveBar = document.getElementById('bridge-save-bar');

        if (saveBar != null && !saveBar.showing && isDirty) {
            saveBar.show();
        }

        if (saveBar != null && saveBar.showing && !isDirty) {
            saveBar.hide();
        }
    }, [isDirty]);

    //const unreadAnnouncementsCount = async () => {
    //    var unreadIndicator = document.querySelector('.unread-indicator');
    //    if (!unreadIndicator) {
    //        return;
    //    }

    //    const data = await fetchGet('api/home/unreadAnnouncementsCount');

    //    if (data > 0) {
    //        document.querySelector('.unread-indicator').innerHTML = data;
    //    }
    //    else {
    //        document.querySelector('.unread-indicator').innerHTML = '';
    //    }
    //};

    const router = createBrowserRouter(
        createRoutesFromElements(
            <Route path="/" element={<Layout isLoading={isLoading} isDirty={isDirty} setIsDirty={setIsDirty} toastActive={toastActive} toastMessage={toastMessage} toggleToastActive={toggleToastActive} user={user} setTriggerSave={setTriggerSave} setTriggerDiscard={setTriggerDiscard} isEmbed={isEmbed} />}>
                <Route index={true} path='/' element={<Home setIsLoading={setIsLoading} changeToastActive={changeToastActive} user={user} setUser={setUser} userLoaded={userLoaded} setUserLoaded={setUserLoaded} isEmbed={isEmbed} />} />
                <Route path='/campaigns' element={<Campaigns setIsLoading={setIsLoading} changeToastActive={changeToastActive} user={user} setUser={setUser} userLoaded={userLoaded} setUserLoaded={setUserLoaded} isEmbed={isEmbed} />} />
                <Route path='/campaigns/new/:type?' element={<Campaign setIsLoading={setIsLoading} changeToastActive={changeToastActive} setIsDirty={setIsDirty} user={user} setUser={setUser} userLoaded={userLoaded} setUserLoaded={setUserLoaded} triggerSave={triggerSave} setTriggerSave={setTriggerSave} triggerDiscard={triggerDiscard} setTriggerDiscard={setTriggerDiscard} isEmbed={isEmbed} isLoading={isLoading} />} />
                <Route path='/campaigns/new/method/:method?' element={<Campaign setIsLoading={setIsLoading} changeToastActive={changeToastActive} setIsDirty={setIsDirty} user={user} setUser={setUser} userLoaded={userLoaded} setUserLoaded={setUserLoaded} triggerSave={triggerSave} setTriggerSave={setTriggerSave} triggerDiscard={triggerDiscard} setTriggerDiscard={setTriggerDiscard} isEmbed={isEmbed} isLoading={isLoading} />} />
                <Route path='/campaigns/:id' element={<Campaign setIsLoading={setIsLoading} changeToastActive={changeToastActive} setIsDirty={setIsDirty} user={user} setUser={setUser} userLoaded={userLoaded} setUserLoaded={setUserLoaded} triggerSave={triggerSave} setTriggerSave={setTriggerSave} triggerDiscard={triggerDiscard} setTriggerDiscard={setTriggerDiscard} isEmbed={isEmbed} isLoading={isLoading} />} />
                <Route path='/campaigns/:id/:action?' element={<Campaign setIsLoading={setIsLoading} changeToastActive={changeToastActive} setIsDirty={setIsDirty} user={user} setUser={setUser} userLoaded={userLoaded} setUserLoaded={setUserLoaded} triggerSave={triggerSave} setTriggerSave={setTriggerSave} triggerDiscard={triggerDiscard} setTriggerDiscard={setTriggerDiscard} isEmbed={isEmbed} isLoading={isLoading} />} />
                <Route path='/analytics' element={<Analytics setIsLoading={setIsLoading} user={user} setUser={setUser} userLoaded={userLoaded} setUserLoaded={setUserLoaded} isEmbed={isEmbed} />} />
                <Route path='/analytics/:id' element={<Analytic setIsLoading={setIsLoading} user={user} setUser={setUser} userLoaded={userLoaded} setUserLoaded={setUserLoaded} isEmbed={isEmbed} />} />
                <Route path='/settings' element={<Settings setIsLoading={setIsLoading} changeToastActive={changeToastActive} setIsDirty={setIsDirty} user={user} setUser={setUser} userLoaded={userLoaded} setUserLoaded={setUserLoaded} triggerSave={triggerSave} setTriggerSave={setTriggerSave} triggerDiscard={triggerDiscard} setTriggerDiscard={setTriggerDiscard} isEmbed={isEmbed} isLoading={isLoading} />} />
                <Route path='/widgets' element={<Widgets setIsLoading={setIsLoading} user={user} setUser={setUser} userLoaded={userLoaded} setUserLoaded={setUserLoaded} isEmbed={isEmbed} isLoading={isLoading} />} />
                <Route path='/widgets/:slug' element={<Widget setIsLoading={setIsLoading} changeToastActive={changeToastActive} setIsDirty={setIsDirty} user={user} setUser={setUser} userLoaded={userLoaded} setUserLoaded={setUserLoaded} triggerSave={triggerSave} setTriggerSave={setTriggerSave} triggerDiscard={triggerDiscard} setTriggerDiscard={setTriggerDiscard} isEmbed={isEmbed} isLoading={isLoading} />} />
                <Route path='/themes' element={<Themes setIsLoading={setIsLoading} changeToastActive={changeToastActive} setIsDirty={setIsDirty} user={user} setUser={setUser} userLoaded={userLoaded} setUserLoaded={setUserLoaded} triggerSave={triggerSave} setTriggerSave={setTriggerSave} triggerDiscard={triggerDiscard} setTriggerDiscard={setTriggerDiscard} isEmbed={isEmbed} isLoading={isLoading} />} />
                <Route path='/themes/main' element={<Theme setIsLoading={setIsLoading} changeToastActive={changeToastActive} setIsDirty={setIsDirty} user={user} setUser={setUser} userLoaded={userLoaded} setUserLoaded={setUserLoaded} triggerSave={triggerSave} setTriggerSave={setTriggerSave} triggerDiscard={triggerDiscard} setTriggerDiscard={setTriggerDiscard} isEmbed={isEmbed} isLoading={isLoading} />} />
                <Route path='/settings/billing' element={<Billing setIsLoading={setIsLoading} user={user} setUser={setUser} userLoaded={userLoaded} setUserLoaded={setUserLoaded} isEmbed={isEmbed} />} />
                <Route path='/settings/partners' element={<Partners setIsLoading={setIsLoading} user={user} setUser={setUser} userLoaded={userLoaded} setUserLoaded={setUserLoaded} isEmbed={isEmbed} />} />
                <Route path='/login/:state?/:error?' element={<Login setIsLoading={setIsLoading} />} />
                <Route path='/error' element={<Error setIsLoading={setIsLoading} />} />
                <Route path='/faq' element={<Faq setIsLoading={setIsLoading} user={user} setUser={setUser} userLoaded={userLoaded} setUserLoaded={setUserLoaded} />} />
                <Route path='/advanced' element={<Advanced setIsLoading={setIsLoading} changeToastActive={changeToastActive} setIsDirty={setIsDirty} triggerSave={triggerSave} setTriggerSave={setTriggerSave} triggerDiscard={triggerDiscard} setTriggerDiscard={setTriggerDiscard} isEmbed={isEmbed} isLoading={isLoading} />} />
                <Route path='/notifications' element={<Announcements setIsLoading={setIsLoading} user={user} setUser={setUser} userLoaded={userLoaded} setUserLoaded={setUserLoaded} isEmbed={isEmbed} />} />
                <Route path='/discountRedirect/:id' element={<DiscountRedirect isEmbed={isEmbed} />} />
            </Route>
        )
    );

    return (
        <RouterProvider
            router={router}
            future={{
                v7_startTransition: true
            }}
        />
    );
}

export default App;